import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { AxnAdminUser } from "@idw-types/data/axn-admin-user";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { AXN_ADMIN_USER_ID_PATTERN } from "@constants/url-parameter-patterns";

type UpdateAxnAdminUserRequestResponse = {
    transferObject: AxnAdminUser;
};

export const deleteAxnAdminUserRequest = async (
    currentUserId: string
): Promise<GenericNetworkResponse<UpdateAxnAdminUserRequestResponse>> => {
    const route = injectCustomIdParameter(
        apiRoutes.axnadminCore.user.delete,
        currentUserId,
        AXN_ADMIN_USER_ID_PATTERN
    );

    const body = {
        id: currentUserId
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};